import { Dialog } from '@angular/cdk/dialog';
import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable({ providedIn: 'root' })
export class NavService {
  public currentUrl = new BehaviorSubject<any>(undefined);

  constructor(
    private router: Router,
    private dialog: Dialog,
    private loadingService: LoadingService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.dialog.closeAll();
        this.loadingService.hide();
        this.currentUrl.next(event.urlAfterRedirects);
      }
    });
  }
}
